export const BASE_URL = "https://staging.skilleareum.ai";
// export const SERVER_URL = "https://skilleareum.ai";
export const SERVER_URL = "https://staging.skilleareum.ai";

export const SUBSCRIPTION_CONTRACT = "0x5D6b1b0fEDBa8650Cd6759da8d501aAfb4A25d7E";
export const PROVIDER_URL = 'https://bnb-testnet.g.alchemy.com/v2/Z4ct64LshtyAtz6tBIbLwg7QCdAl0jKW'

export const MAILGUN_API_KEY =
  "9cd37b7da2d8853f8ab7a8737b1a196e-6fafb9bf-1c305670";

export const BSCMASTERCONTRACT = "0x1b1ECb4caEE7e652782d50c9B3459c71e04846BE";
export const MATICMASTERCONTRACT = "0x88AC17b0b740D59E6809296cAf7328edac6e2FF6";
export const USDAMOUNT = "";
export const Speak = (text) => {
  // console.log(text); // Logs the text to the console
  // const synth = window.speechSynthesis;
  // // Function to speak the text with a female voice
  // const speakText = () => {
  //   const voices = synth.getVoices();
  //   // Select a female voice
  //   const femaleVoice = voices.find(
  //     (voice) =>
  //       voice.name.includes("Female") ||
  //       voice.name.includes("Google US English") ||
  //       voice.lang === "en-US" // Fallback for English voice
  //   );
  //   const msg = new SpeechSynthesisUtterance(text); // Create a new utterance with the passed text
  //   if (femaleVoice) {
  //     msg.voice = femaleVoice;
  //   }
  //   msg.onend = function (event) {
  //     console.log("Speech ended");
  //   };
  //   msg.onerror = function (event) {
  //     console.error("SpeechSynthesisUtterance.onerror", event);
  //   };
  //   synth.speak(msg); // Speak the utterance
  // };
  // // Check if voices are already loaded
  // if (synth.getVoices().length !== 0) {
  //   speakText();
  // } else {
  //   // Add an event listener to handle the voices changed event
  //   synth.onvoiceschanged = () => {
  //     speakText();
  //   };
  // }
};

export const ABI = [
  {
    inputs: [
      { internalType: "address", name: "admin", type: "address" },
      { internalType: "address", name: "_router", type: "address" },
      { internalType: "address", name: "_payoutToken", type: "address" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  { inputs: [], name: "AccessControlBadConfirmation", type: "error" },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "bytes32", name: "neededRole", type: "bytes32" },
    ],
    name: "AccessControlUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "ADMINWALLETCHANGED",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "role", type: "bytes32" },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      { indexed: false, internalType: "bool", name: "status", type: "bool" },
    ],
    name: "adminAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      { indexed: false, internalType: "bool", name: "status", type: "bool" },
    ],
    name: "adminRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "prevPercentage",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newPercentage",
        type: "uint256",
      },
    ],
    name: "partnersPercentageChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "prevPercentage",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newPercentage",
        type: "uint256",
      },
    ],
    name: "referralPercentageChnaged",
    type: "event",
  },
  { stateMutability: "payable", type: "fallback" },
  {
    inputs: [],
    name: "ADMIN_ROLE",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ADMIN_WALLET",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "Pause",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newAdmin", type: "address" }],
    name: "addADMIN_ROLE",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "partnerName", type: "string" },
      { internalType: "uint256", name: "referralPercentage", type: "uint256" },
    ],
    name: "addNewPartners",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newAdmin", type: "address" }],
    name: "changeAdmin",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "partnersId", type: "bytes32" },
      { internalType: "uint256", name: "newpercentage", type: "uint256" },
    ],
    name: "changePartnerPercentage",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimBonus",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "partnersName", type: "string" }],
    name: "getPartnersId",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getReferralBonus",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRewardlBonus",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "role", type: "bytes32" }],
    name: "getRoleAdmin",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "hasRole",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "referrer", type: "address" },
          { internalType: "bytes32", name: "referralId", type: "bytes32" },
          { internalType: "address", name: "paymentToken", type: "address" },
          { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        internalType: "struct SkilleareumEscrowWallet.registerParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "registerwithReferralwithETH",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "referrer", type: "address" },
          { internalType: "bytes32", name: "referralId", type: "bytes32" },
          { internalType: "address", name: "paymentToken", type: "address" },
          { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        internalType: "struct SkilleareumEscrowWallet.registerParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "registerwithReferralwithTokens",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "admin", type: "address" }],
    name: "removeADMIN_ROLE",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "callerConfirmation", type: "address" },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes32", name: "role", type: "bytes32" },
      { internalType: "address", name: "account", type: "address" },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalAllocatedReferralRewards",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalAllocatedRewards",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "user", type: "address[]" },
      { internalType: "uint256[]", name: "bonus", type: "uint256[]" },
    ],
    name: "updateBonusDetails",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address[]", name: "_users", type: "address[]" },
      { internalType: "address[]", name: "referrer", type: "address[]" },
    ],
    name: "updateReferrerDetails",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "userStats",
    outputs: [
      { internalType: "uint256", name: "totalreward", type: "uint256" },
      { internalType: "uint256", name: "totalbonus", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "users",
    outputs: [
      { internalType: "bytes32", name: "referrerId", type: "bytes32" },
      { internalType: "address", name: "referrer", type: "address" },
      { internalType: "uint256", name: "amountSpented", type: "uint256" },
      { internalType: "uint256", name: "amountFreezed", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawETH",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "token", type: "address" }],
    name: "withdrawTokens",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  { stateMutability: "payable", type: "receive" },
];

// useEffect(() => {
//   // Ensure voices are loaded
//   const loadVoices = () => {
//     const [voices, setVoices] = useState([]);
//     const availableVoices = window.speechSynthesis.getVoices();
//     setVoices(availableVoices);
//   };

//   // Load voices asynchronously if needed
//   if (window.speechSynthesis.onvoiceschanged !== undefined) {
//     window.speechSynthesis.onvoiceschanged = loadVoices;
//   }
//   loadVoices();
// }, []);

export const handleSpeak = (text) => {
  if (!text) return;



  // Cancel any ongoing speech to avoid overlap
  window.speechSynthesis.cancel();

  // Create a new instance for speech synthesis
  const speech = new SpeechSynthesisUtterance(text);

  // Select a voice, if available
  // if (voices.length > 0) {
  //   speech.voice = voices[0]; // Adjust index or add selection for different voices
  // }

  // Set speech properties
  speech.rate = 1; // Speed
  speech.pitch = 1; // Pitch
  speech.lang = 'en-US'; // Language

  // Start speaking
  // window.speechSynthesis.speak(speech);
};
export const ELEVEN_LABS_API_KEY =
  "sk_df6f8cc41a927b3585d3ead81088612f422d1d19188b555e";
export const ELEVEN_LABS_VOICE_ID = "pNInz6obpgDQGcFmaJgB";

export const speak = async (text) => {
  // try {
  //   const response = await fetch(
  //     `https://api.elevenlabs.io/v1/text-to-speech/${ELEVEN_LABS_VOICE_ID}`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "audio/mpeg",
  //         "xi-api-key": ELEVEN_LABS_API_KEY,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         text: text,
  //         model_id: "eleven_monolingual_v1",
  //         voice_settings: {
  //           stability: 0.5,
  //           similarity_boost: 0.5,
  //         },
  //       }),
  //     }
  //   );

  //   if (!response.ok) {
  //     throw new Error("Failed to generate speech");
  //   }

  //   const audioBlob = await response.blob();
  //   const audioUrl = URL.createObjectURL(audioBlob);
  //   const audio = new Audio(audioUrl);
  //   audio.play();
  // } catch (error) {
  //   console.error("Error in Eleven Labs text-to-speech:", error);
  //   // Fallback to original speech synthesis
  //   const msg = new SpeechSynthesisUtterance(text);
  //   const voices = window.speechSynthesis.getVoices();
  //   // Select a female voice
  //   const femaleVoice = voices.find(
  //     (voice) =>
  //       voice.name.includes("Female") ||
  //       voice.name.includes("Google US English") ||
  //       voice.gender === "female"
  //   );
  //   if (femaleVoice) {
  //     msg.voice = femaleVoice;
  //   }
  //   msg.onend = function (event) {};
  //   msg.onerror = function (event) {
  //     console.error("SpeechSynthesisUtterance.onerror", event);
  //   };
  //   window.speechSynthesis.speak(msg);
  // }
};
